export default "__VITE_ASSET__BzVL53U3__"